import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { WhatsAppIcon } from "./Logo";
import { waLink, WHATSAPP_ENABLED } from "../../config";
import { track } from "../../lib/tracking";

export default function FloatingWhatsApp() {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!WHATSAPP_ENABLED) return null;

  return (
    <div className="fixed bottom-5 right-4 sm:bottom-6 sm:right-6 z-50 flex flex-col items-end gap-3">
      <AnimatePresence>
        {open && (
          <motion.a
            initial={{ opacity: 0, y: 12, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.9 }}
            transition={{ duration: 0.25 }}
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-bubble"
            className="max-w-[240px] rounded-2xl bg-white shadow-2xl border border-gray-100 px-4 py-3 text-sm text-ink"
          >
            <span className="font-semibold text-navy">Scrivici su WhatsApp</span>
            <br />
            Rispondiamo in fretta con un preventivo gratuito.
          </motion.a>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {show && (
          <motion.a
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.6 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            onClick={() => { setOpen(true); track.whatsappClick("floating"); }}
            data-testid="floating-whatsapp-button"
            aria-label="Contattaci su WhatsApp"
            className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.8)] hover:scale-105 transition-transform duration-300"
          >
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
            <WhatsAppIcon size={28} className="relative" />
          </motion.a>
        )}
      </AnimatePresence>
    </div>
  );
}
